import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
  root: {
    width: 150,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '@media (max-width: 600px)': {
      width: 100,
    },
  },
}))
